import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: 'Is this just for ER visits?',
  answer: "No. While it's built for emergencies, it's perfect for specialist appointments, new doctor visits, or just keeping track of daily meds and symptoms at home. It's your child's full medical story in one place."
}, {
  question: 'What format is it? Can I print at home?',
  answer: "It's a standard PDF file designed to print perfectly on regular 8.5x11 paper. You can print it at home, at a library, or at a print shop. You can also fill it out digitally on a tablet before printing."
}, {
  question: 'Can I share this with my partner/co-parent?',
  answer: 'Yes! The license covers your immediate household. We encourage you to print copies for grandparents, babysitters, and school nurses too.'
}, {
  question: 'What if my child has multiple conditions?',
  answer: 'The binder is designed to be flexible. You can print extra copies of the Symptom Log, Medication Map, or Specialist pages as needed to cover everything.'
}, {
  question: "I'm not tech-savvy. Is this hard to use?",
  answer: 'Not at all. You just download the PDF, open it, and print. If you can print a document, you can use this kit. No special apps or software required.'
}];
export function FaqSection() {
  return <section id="faq" className="w-full py-20 px-6 bg-cream" data-id="element-32">
      <div className="max-w-3xl mx-auto" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-34">
          <h2 className="text-3xl font-bold text-navy font-serif mb-4" data-id="element-35">
            Frequently Asked Questions
          </h2>
          <p className="text-body text-lg" data-id="element-36">Common questions from other moms.</p>
        </motion.div>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, i) => <FaqItem key={i} question={faq.question} answer={faq.answer} index={i} data-id="element-38" />)}
        </div>
      </div>
    </section>;
}
function FaqItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className="bg-white rounded-lg border border-soft-sage/30 overflow-hidden" data-id="element-39">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-40">
        <span className="font-bold text-navy text-lg" data-id="element-41">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-teal flex-shrink-0" data-id="element-42" /> : <ChevronDown className="w-5 h-5 text-teal flex-shrink-0" data-id="element-43" />}
      </button>
      <div className={`px-6 text-body leading-relaxed overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-44">
        {answer}
      </div>
    </motion.div>;
}